import React from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import DashboardLayout from '../components/DashboardLayout';

const AdminRoles = () => {
  const roles = [
    {
      name: 'ADMIN',
      description: 'Full system access with all permissions',
      permissions: ['*'],
    },
    {
      name: 'MODERATOR',
      description: 'Moderation access for content and users',
      permissions: ['users.read', 'users.update', 'posts.read', 'posts.update', 'posts.delete'],
    },
    {
      name: 'USER',
      description: 'Standard user access',
      permissions: ['users.read', 'posts.read', 'posts.create'],
    },
  ];

  return (
    <ProtectedRoute roles={['ADMIN']}>
      <DashboardLayout title="Role Management" roles={['ADMIN']}>
        <div className="space-y-4">
          {roles.map((role) => (
            <div key={role.name} className="bg-white shadow rounded-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-gray-900">{role.name}</h3>
                <span className="px-3 py-1 text-sm font-medium rounded-full bg-blue-100 text-blue-800">
                  {role.permissions.length} Permission{role.permissions.length !== 1 ? 's' : ''}
                </span>
              </div>
              <p className="text-gray-600 mb-4">{role.description}</p>
              <div>
                <h4 className="text-sm font-medium text-gray-700 mb-2">Permissions:</h4>
                <div className="flex flex-wrap gap-2">
                  {role.permissions.map((permission, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 text-xs font-medium rounded bg-gray-100 text-gray-800"
                    >
                      {permission}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 className="text-sm font-medium text-blue-900 mb-2">Note:</h4>
          <p className="text-sm text-blue-800">
            Roles are managed in the database. To modify roles or permissions, update the Role model
            in the backend or use the MongoDB interface.
          </p>
        </div>
      </DashboardLayout>
    </ProtectedRoute>
  );
};

export default AdminRoles;
